
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxSessionViewComponent } from '@go-modules/components/feedback-session/session-view/session-view.component';
import { FeedbackSessionDirective } from '@go-modules/angularjs-wrappers/feedback-session.directive';
import { FeedbackSessionHeaderDirective } from '@go-modules/angularjs-wrappers/feedback-session-header.directive';
import { LoadingModule } from '@go-modules/components/loading/loading.module';

@NgModule({
	imports: [
		CommonModule,
		LoadingModule
	],
	declarations: [
		NgxSessionViewComponent,
		FeedbackSessionDirective,
		FeedbackSessionHeaderDirective
	],
	exports: [
		NgxSessionViewComponent
	]
})
export class NgxSessionViewModule {}
